var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.057 7.76122C21.0663 7.97242 21.0663 8.17402 21.0663 8.38523C21.0755 14.7884 16.3711 22.1805 7.76781 22.1805C5.23036 22.1805 2.73921 21.4221 0.599976 20.0013C0.970406 20.0493 1.34084 20.0685 1.71127 20.0685C3.81346 20.0685 5.86009 19.3389 7.51777 17.9853C5.51744 17.9469 3.7579 16.5933 3.14669 14.6156C3.8505 14.7596 4.57284 14.7308 5.25814 14.5292C3.08186 14.0876 1.51679 12.1004 1.50753 9.78683C1.50753 9.76763 1.50753 9.74843 1.50753 9.72923C2.15578 10.1036 2.88738 10.3148 3.62825 10.334C1.58162 8.91323 0.942624 6.08122 2.18357 3.86361C4.56358 6.89722 8.06415 8.73083 11.824 8.93243C11.4443 7.25242 11.9629 5.48602 13.1761 4.29561C15.056 2.46201 18.0195 2.55801 19.7975 4.50681C20.844 4.29561 21.8534 3.89241 22.7702 3.32601C22.4183 4.44921 21.6867 5.39962 20.7144 6.00442C21.6404 5.88922 22.548 5.63002 23.4 5.24601C22.7702 6.22522 21.9738 7.07002 21.057 7.76122Z",
    fill: "#1D9BF0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ad501982b80b39dc9de4a939e597b356.svg";
export { ForwardRef as ReactComponent };